import { render, staticRenderFns } from "./MoleculeTitleAndDescription.vue?vue&type=template&id=f852f492&scoped=true&"
import script from "./MoleculeTitleAndDescription.vue?vue&type=script&lang=js&"
export * from "./MoleculeTitleAndDescription.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeTitleAndDescription.vue?vue&type=style&index=0&id=f852f492&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f852f492",
  null
  
)

export default component.exports